import type { IPublicClientApplication } from '@azure/msal-browser';

export function isLoggedInForDemo(msalInstance: IPublicClientApplication): boolean {
	return msalInstance.getAllAccounts().length > 0;
}
